import { useLocation, useParams } from 'react-router-dom';

import EmbryoBank from '../../features/embryos/layouts/bank';
import EmbryoDetail from '../../features/embryos/layouts/detail';
import CreateEmbryoForm from '../../features/embryos/forms/create';

// TSS vite/01 §"Pages are thin".
export default function EmbryosPage() {
    const { id } = useParams();
    const { pathname } = useLocation();

    if (pathname.endsWith('/new')) return <CreateEmbryoForm />;
    if (id) return <EmbryoDetail embryoId={id} />;
    return <EmbryoBank />;
}
